import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import YouthDevelopmentMentorshipDetails from '../../subdepartmentdetails/YouthDevelopmentMentorship'


function YouthDevelopmentMentorship() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Youth Development || Education";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Education Youth Services"
            title="Youth Development Mentorship"
            subtitledown="Department of Education"
           />
            <YouthDevelopmentMentorshipDetails/>
        </div>
    </>
  )
}

export default YouthDevelopmentMentorship